import useModalVersion from '@/hooks/modals/useModalVersion';
import { ModalLayout } from '@starsoft/common/components';
import { ModalLayoutProps } from '@starsoft/common/components/Modal/Layout/props';
import { PropsWithChildren } from 'react';

export function ModalWithVersion({
  title,
  modal,
  ...props
}: Omit<PropsWithChildren<ModalLayoutProps>, 'version'>) {
  const { version } = useModalVersion();

  return (
    <ModalLayout title={title} modal={modal} {...props} version={version} />
  );
}
